export const ROOT_PATH = '/';
export const HOME_BROWSE_PATH = '/radio/home/';
export const SPORTS_BROWSE_PATH = '/radio/sports/';
export const MUSIC_BROWSE_PATH = '/radio/music/';
export const NEWS_BROWSE_PATH = '/radio/News--Talk-c57922/';
export const PODCASTS_BROWSE_PATH = '/podcasts/';
export const PREMIUM_BROWSE_PATH = '/radio/premium/';

export const PAYMENT_PATH = '/payment/';
export const PAYMENT_COMPLETE_PATH = '/paymentcomplete/';
export const RENEW_PATH = '/renew/';
export const SUBSCRIBE_PATH = '/subscribe/';
export const COUPON_PATH = '/coupon/';
export const UPDATE_PAYMENT_PATH = '/update/paymentmethod';

export const AUTHORIZE_PATH = '/authorize/';
export const AUTHORIZE_CONFIRM_PATH = '/authorize/confirm/';

export const LOGIN_PATH = '/login/';
export const ACCOUNT_NEW_RESET_PATH = '/account/new/reset/';
export const ACCOUNT_PATH = '/account/';
export const ACCOUNT_DEVICES_PATH = '/devices/';
export const ACCOUNT_PAYMENT_PATH = '/payment/';

export const USER_PATH = '/user/:userName/';
export const USER_FAVORITES_PATH = '/user/:userName/favorites';

export const SEARCH_PATH = '/search/';

export const DATA_PATH = '/data/';

export const OPT_OUT_PATH = '/optout/';

export const DATA_REQUEST_AUTH_PATH = '/datarequest/';
export const DATA_REQUEST_CONFIRM_PATH = '/datarequest/confirm/';

export const AUTO_PATH = '/auto/';
